import {
  BalanceReportCard,
  PaymentMethodBalanceReportCard,
  TerminalPollReportCard,
  ProviderReportCard,
  TransactionsReportCard,
  ReconciliationReportCard,
  ChargebackReportCard,
} from '../components';

export const ReportsPage = () => (
    <header>
        <h1 className="mb-4 text-4xl text-brand-6 font-bold">Reports</h1>
        <ul className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(400px, 100%), 1fr))' }}>
            <TransactionsReportCard/>
            <BalanceReportCard/>
            <PaymentMethodBalanceReportCard/>
            <ProviderReportCard/>
            <TerminalPollReportCard/>
            <ReconciliationReportCard/>
            <ChargebackReportCard/>
        </ul>
    </header>
);
